import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError} from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class UtilService {
    url = "";
    totalplot: number = 6;
    
    constructor(private http: HttpClient) {
        this.url = environment.API;
    }

    public getProvinces(): Observable<any> {
        return this.http.get<any>(`${this.url}farms/util/provinces`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getDistricts(id): Observable<any> {
        return this.http.get<any>(`${this.url}farms/util/district/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getSubDistricts(id): Observable<any> {
        return this.http.get<any>(`${this.url}farms/util/subDistricts/${id}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
}
